import { Component, computed, inject, OnInit, signal } from '@angular/core';
import { DatePipe } from '@angular/common';
import { NotificationService } from '../../../features/notifications/services/notification.service';
import { SidebarService } from '../../services/sidebar.service';
import { SidebarPanelType } from '../../models/sidebar-panel';
import { NotificationItem } from '../../../features/notifications/models/notification';
import { NotificationTypes } from '../../constants/domain.constants';

type NotificationTab = 'all' | 'messages' | 'alerts';

@Component({
  selector: 'app-notification-list-panel',
  imports: [DatePipe],
  templateUrl: './notification-list-panel.component.html',
  styleUrl: './notification-list-panel.component.scss'
})
export class NotificationListPanelComponent implements OnInit {
  private readonly notificationService = inject(NotificationService);
  private readonly sidebarService = inject(SidebarService);

  readonly activeTab = signal<NotificationTab>('all');
  readonly loading = computed(() => this.notificationService.loading());
  readonly error = computed(() => this.notificationService.error());

  readonly filteredNotifications = computed(() => {
    const items = this.notificationService.notifications();
    const tab = this.activeTab();

    if (tab === 'messages') {
      return items.filter((item) => item.notificationType === NotificationTypes.message);
    }
    if (tab === 'alerts') {
      return items.filter((item) => item.notificationType === NotificationTypes.alert);
    }
    return items;
  });

  readonly NotificationTypes = NotificationTypes;

  ngOnInit(): void {
    this.notificationService.refresh();
  }

  setTab(tab: NotificationTab): void {
    this.activeTab.set(tab);
  }

  openDetail(notification: NotificationItem): void {
    this.sidebarService.push({
      type: SidebarPanelType.NotificationDetail,
      data: notification
    });
  }

  dismiss(event: Event, notificationId: string): void {
    event.stopPropagation();
    this.notificationService.markAsRead(notificationId);
  }

  dismissAll(): void {
    this.notificationService.markAllAsRead();
  }
}
